export const BYTES_IN_KB = 1024;
export const BYTES_IN_MB = 1024 * BYTES_IN_KB;
export const BYTES_IN_GB = 1024 * BYTES_IN_MB;

/**
 * Human-readable size for plan limits and storage meters. Deliberately coarse — these are quota
 * figures shown to a user ("of 5.0 GB pooled"), not exact file sizes.
 */
export function formatBytes(bytes: number): string {
  if (bytes >= BYTES_IN_GB) return `${(bytes / BYTES_IN_GB).toFixed(1)} GB`;
  if (bytes >= BYTES_IN_MB) return `${Math.round(bytes / BYTES_IN_MB)} MB`;
  if (bytes >= BYTES_IN_KB) return `${Math.round(bytes / BYTES_IN_KB)} KB`;
  return `${bytes} B`;
}

export function mbToBytes(mb: number): number {
  return Math.round(mb * BYTES_IN_MB);
}

export function bytesToMb(bytes: number): number {
  return bytes / BYTES_IN_MB;
}
